import { render, staticRenderFns } from "./global-dashboard-settings-view.vue?vue&type=template&id=141d62f6"
import script from "./global-dashboard-settings-view.vue?vue&type=script&lang=js"
export * from "./global-dashboard-settings-view.vue?vue&type=script&lang=js"
import style0 from "./global-dashboard-settings-view.vue?vue&type=style&index=0&id=141d62f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports